import React, { CSSProperties, useState } from 'react';
import { FileUploadFile } from 'primereact/fileupload';
import { UploadFile } from '../../../../../../../user-page/pages/docs/componenets/upload-file/upload-file';
import { Button } from 'primereact/button';
import { uploadExamQuestionnaireOperations } from './operations/upload-exam-questionnaire-operations';
import {
  ExamSessionDetails,
  ExamSessionFile,
} from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import globalProgramStore from '../../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import dateUtils from '../../../../../../../../utils/date-format';
import { deleteExamQuestionnaireOperation } from './operations/delete-exam-questionnaire-operation';
import { Dialog } from 'primereact/dialog';

interface ExaminationQuestionnaireDatamodel {
  examId: number;
  examSession: ExamSessionDetails | null;
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}

const columnStyle: CSSProperties = {
  textAlign: 'right',
  minWidth: '30px',
  maxWidth: '30px',
};

export const ExaminationQuestionnaire: React.FC<
  ExaminationQuestionnaireDatamodel
> = ({ examId, examSession, setSessionDetails }) => {
  const [displayAddDialog, setDisplayAddDialog] = useState(true);

  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();

  const uploadFile = async () => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    await uploadExamQuestionnaireOperations(
      currentProgramId,
      currentCourseId,
      examId,
      examSession?.id,
      uploadedFile,
      setSessionDetails,
      setAddQuestionnaireDialog,
    );
  };

  const handleDelete = async (fileId: number) => {
    const programId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    await deleteExamQuestionnaireOperation(
      programId,
      currentCourseId,
      examId,
      examSession?.id,
      fileId,
      setSessionDetails,
    );
  };

  const [addQuestionnaireDialog, setAddQuestionnaireDialog] = useState(false);

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
      }}
    >
      {examSession?.files.length === 0 && (
        <div
          style={{
            minHeight: '400px',
            minWidth: '400px',
            maxWidth: '50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <UploadFile onFileUploaded={setUploadedFile} />
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}
          >
            <Button
              style={{ height: '35px', marginTop: '16px' }}
              label={'שמירת קובץ'}
              onClick={uploadFile}
            />
          </div>
        </div>
      )}

      <Dialog
        header="הוספת קובץ"
        visible={addQuestionnaireDialog}
        style={{
          width: '40vw',
          /*minWidth: '40wh',*/
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setAddQuestionnaireDialog(false);
        }}
      >
        <UploadFile onFileUploaded={setUploadedFile} />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            style={{ height: '35px', marginTop: '16px' }}
            label={'העלאת קובץ'}
            onClick={uploadFile}
          />
        </div>
      </Dialog>

      {examSession?.files.length > 0 && (
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode={'multiple'}
          multiple={true}
          groupRowsBy="dsf"
          value={examSession.files}
          scrollable
          onSelectionChange={(e) => {
            //setSelectedUsers(e.value as UserSummaryType[]);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '16px',
          }}
        >
          <Column
            expander={false}
            header="שם קובץ"
            field={'fileName'}
            style={columnStyle}
          />

          <Column
            expander={false}
            header="תאריך יצירה"
            field={'nationalId'}
            style={columnStyle}
            body={(rowData) => (
              <label>{dateUtils.displayFormatDate(rowData.createdAt)}</label>
            )}
          />

          <Column
            expander={false}
            header={'נוצא ע״י'}
            field={'createdByName'}
            style={columnStyle}
          />

          <Column
            expander={false}
            header={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  paddingRight: '9px',
                }}
              >
                <Button
                  icon="pi pi-plus"
                  tooltip="להוספת מסמך"
                  style={{ height: '30px', width: '30px' }}
                  tooltipOptions={{ position: 'top' }}
                  className="p-button-rounded p-button-primary"
                  onClick={() => setAddQuestionnaireDialog(true)}
                />
              </div>
            }
            field={'createdByName'}
            style={columnStyle}
            body={(rowData: ExamSessionFile) => (
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                onClick={() => handleDelete(rowData.id)}
              />
            )}
          />
        </DataTable>
      )}
    </div>
  );
};
